const actionCreators = {
  serverRenderStart(params) {
    return {
      type: 'SERVER_RENDER_START',
      payload: {
        params,
      },
    }
  },
  pageRenderStart(params) {
    return {
      type: 'PAGE_RENDER_START',
      payload: {
        params,
      },
    }
  },
  domLoaderEnd(params) {
    return {
      type: 'DOM_LOADER_END',
      payload: {
        params,
      },
    }
  },
  pageRenderEnd(params) {
    return {
      type: 'PAGE_RENDER_END',
      payload: {
        params,
      },
    }
  },
};

export {
  actionCreators,
};
